import { combineEpics } from 'redux-observable';

import * as loadDataEpics from '../services/loadData.epic';

const rootEpic = combineEpics(
  ...Object.values(loadDataEpics)
);

export default rootEpic;
